import { useContext, ref } from '@nuxtjs/composition-api'
import { useLoading } from './ui/useLoading'
import { Voucher, VoucherByCodeResult } from '@/types/promotion'

const getVouchersLoading = useLoading()
const paymentVouchers = ref<Voucher[] | null>(null)
const productVouchers = ref<Voucher[] | null>(null)

const getVoucherByCodeLoading = useLoading()
const voucherByCode = ref<VoucherByCodeResult | null>(null)

export const usePromotion = () => {
  const { app } = useContext()

  const getVouchers = () => {
    return getVouchersLoading.scope(async () => {
      const result = await app.$api.promotion.getVouchers()
      if (!result) return

      paymentVouchers.value = result.paymentVouchers
      productVouchers.value = result.productVouchers
    })
  }

  const getVoucherByCode = (code: string) => {
    return getVoucherByCodeLoading.scope(async () => {
      const result = await app.$api.promotion.getVoucherByCode(code)
      voucherByCode.value = result
    })
  }

  return {
    getVouchersLoading: getVouchersLoading.value,
    getVoucherByCodeLoading: getVoucherByCodeLoading.value,
    paymentVouchers,
    productVouchers,
    getVouchers,

    voucherByCode,
    getVoucherByCode,
  }
}
